import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import { Stack } from '@mui/material';

type TResult = {
  label: string;
  to: string;
  IconComponent: (props: { fontSize?: 'small' }) => JsxNode;
};
type Props = {
  links: TResult[];
};

export default function NavigationLinksDesktop({ links }: Props) {
  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      sx={{ flexBasis: '100%', display: { xs: 'none', lg: 'flex' } }}
    >
      {links.map(({ to, label }, i) => (
        <ButtonLink key={i} href={to} size="small" sx={{ color: 'inherit' }}>
          {label}
        </ButtonLink>
      ))}
    </Stack>
  );
}
